<rt-dialog-header
  [heading]="editMode ? texts.headingEdit : texts.headingCreate"
  [subheading]="texts.subheading"
></rt-dialog-header>
<rt-dialog-body layout-vertical>
  @if (disablePublish) {
    <rt-infobox [isDismissible]="false" iconName="info-outline" margin-bottom>
      <p [innerHTML]="texts.infobox"></p>
    </rt-infobox>
  }
  @if (isValidationErrorInfoboxVisible) {
    <rt-infobox [isDismissible]="false" type="error" iconName="error" margin-bottom>
      <p [innerHTML]="validationErrorInfoboxText"></p>
    </rt-infobox>
  }
  <rt-form-field>
    <rt-label>{{ texts.publishDate }}</rt-label>
    <rt-input
      #publishDateDropdownOrigin="rtOverlayOrigin"
      [hasDropdownIndicator]="true"
      [disabled]="disablePublish"
      [readOnly]="!disablePublish"
      [placeholder]="texts.placeholder"
      [value]="displayPublishDate"
      [class.dropdownOpened]="publishDatePickerOpen"
      (click)="!disablePublish && togglePublishDatePicker()"
      rt-overlay-origin
    ></rt-input>
  </rt-form-field>
  <rt-form-field margin-top>
    <rt-label>
      {{ texts.closeDate }}
    </rt-label>
    <rt-input
      #closeDateDropdownOrigin="rtOverlayOrigin"
      [hasDropdownIndicator]="true"
      [readOnly]="true"
      [placeholder]="texts.placeholder"
      [class.dropdownOpened]="closeDatePickerOpen"
      [value]="displayCloseDate"
      (click)="toggleCloseDatePicker()"
      variant="rounded"
      rt-overlay-origin
    ></rt-input>
  </rt-form-field>
  <div margin-top-small-x layout>
    <rt-time-zone-picker
      [timezone]="timezone"
      [small]="true"
      [positions]="timezoneDropdownPosition"
      (zoneChange)="setTimezone($event)"
    ></rt-time-zone-picker>
  </div>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button (click)="cancel()" variant="plain">{{ texts.cancel }}</rt-button>
  <rt-button [disabled]="!isValid" (click)="isValid && save()" variant="primary">
    {{ scheduleButtonLabel }}
  </rt-button>
</rt-dialog-footer>

<ng-template
  #publishDateDropdown="rtConnectedOverlay"
  [origin]="publishDateDropdownOrigin"
  [open]="publishDatePickerOpen"
  (backdropClick)="closePickers()"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown (click)="$event.preventDefault()">
    <rt-date-picker
      direction="today-future"
      [value]="publishDate"
      [selectNowByDefault]="false"
      [blackout]="isPublishDateDisabled.bind(this)"
      [viewStartDate]="publishStartDateView"
      (valueChange)="setPublish($event); closePickers()"
    ></rt-date-picker>

    @if (publishDate) {
      <ng-container
        *ngTemplateOutlet="clearBtnTpl; context: { handler: setPublish.bind(this) }"
      ></ng-container>
    }
  </rt-dropdown>
</ng-template>

<ng-template
  #closeDateDropdown="rtConnectedOverlay"
  [origin]="closeDateDropdownOrigin"
  [open]="closeDatePickerOpen"
  (backdropClick)="closePickers()"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown (click)="$event.preventDefault()">
    <rt-date-picker
      direction="future"
      [value]="closeDate"
      [blackout]="isCloseDateDisabled.bind(this)"
      [selectNowByDefault]="false"
      [viewStartDate]="closeStartDateView"
      (valueChange)="setClose($event); closePickers()"
    ></rt-date-picker>

    @if (closeDate) {
      <ng-container
        *ngTemplateOutlet="clearBtnTpl; context: { handler: setClose.bind(this) }"
      ></ng-container>
    }
  </rt-dropdown>
</ng-template>

<ng-template #clearBtnTpl let-handler="handler">
  <div layout layout-justify-center layout-align-items-center>
    <div margin-tb-medium>
      <rt-button
        variant="plain"
        (click)="handler(''); closePickers()"
        class="clear-button"
        layout-full-width
      >
        <rt-icon name="close"></rt-icon>
        <span> {{ texts.clear }}</span>
      </rt-button>
    </div>
  </div>
</ng-template>
